import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('show.zf.dropdown', '[data-item-graduated-prices]', function() {
  const $this = $(this);
  const $link = $(`[data-toggle="${this.id}"]`);

  load(
    $this,
    $.ajax({
      url: $link.attr('href'),
      method: 'GET',
    }).then((html) => {
      this.innerHTML = html;
      $this.removeAttr('data-item-graduated-prices');
      return html;
    }),
  );
});

$(document).on('click', '[data-item-graduated-prices-toggle]', (event) => {
  event.preventDefault();
});
